import { CommonInput } from 'components';
import Tab from 'components/common/Tab'
import { constant } from 'constants/constant';
import React, { useState } from 'react'

const Branch = () => {

    const [activeTab, setActiveTab] = useState(1);

    const callBackTab = (data) => {
        setActiveTab(data);
    }

    const brannchProps = {
        tabList: constant.branchSettingTabs,
        callBackTab: callBackTab,
        activeTab: activeTab
    }

    return (
        <>
            <div className='__setsHeads'>
                <h4>Branch Name</h4>
                <span className='__idTag'>Code: B243</span>
            </div>

            <div className='__setsContent_prt'>
                <Tab {...brannchProps} invoiceBillRaiseClass="settingTbs" />

                {activeTab === 1 && (
                    <>
                        <div className='__stContent' style={{ paddingTop: '1em' }}>


                            <div className='__cprPr_otr'>
                                <div className='__cprPr_inr'>

                                    <div>
                                        <div className='__cprPr_fxOtr'>
                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Branch Name"
                                                        placeholder="Branch Name"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Branch Code"
                                                        placeholder="Branch Code"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Mobile Number"
                                                        placeholder="Mobile Number"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Alternate Contact Number"
                                                        placeholder="Alternate Contact Number"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Email ID"
                                                        placeholder="Email ID"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Website"
                                                        placeholder="Website"
                                                        name='name'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p className='__cp_head'>GST Registration</p>
                                        <div className='__cprPr_fxOtr'>
                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="GST Number"
                                                        placeholder="GST Number"
                                                        name='name'
                                                    />
                                                </div>
                                            </div>

                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="PAN Number"
                                                        placeholder="PAN Number"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Fssai License Number"
                                                        placeholder="Fssai License Number"
                                                        name='name'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p className='__cp_head'>Business Address</p>
                                        <div className='__cprPr_fxOtr'>
                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_full'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Address"
                                                        placeholder="Address"
                                                        name='name'
                                                    />
                                                </div>
                                            </div>

                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="City"
                                                        placeholder="City"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="State"
                                                        placeholder="State"
                                                        name='name'
                                                    />
                                                </div>

                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="PIN Code"
                                                        placeholder="PIN Code"
                                                        name='name'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <p className='__cp_head'>Sequence</p>
                                        <div className='__cprPr_fxOtr'>
                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="LR Number"
                                                        placeholder="LR Number"
                                                        name='name'
                                                    />
                                                </div>
                                            </div>

                                            <div className='__cprPr_fxInr'>
                                                <div className='__cp_flex_half'>
                                                    <CommonInput
                                                        type="text"
                                                        label="Trip Number"
                                                        placeholder="Trip Number"
                                                        name='name'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className='__setFooter'>
                            <button className='__setBtn  __setBtn_update'>Update</button>
                            <button className='__setBtn  __setBtn_cancel'>Cancel</button>
                        </div>
                    </>
                )}

                {activeTab === 2 && (
                    <>
                        <div className='__stContent'>2</div>
                        <div></div>
                    </>
                )}

                {activeTab === 3 && (
                    <>
                        <div className='__stContent'>3</div>
                        <div></div>
                    </>
                )}

                {activeTab === 4 && (
                    <>
                        <div className='__stContent'>4</div>
                        <div></div>
                    </>
                )}

                {activeTab === 5 && (
                    <>
                        <div className='__stContent'>5</div>
                        <div></div>
                    </>
                )}

                {activeTab === 6 && (
                    <>
                        <div className='__stContent'>6</div>
                        <div></div>
                    </>
                )}
            </div>

        </>
    )
}

export default Branch